<template>
  <div
    class="update-step"
    data-tst="update_success"
  >
    <div class="update-step_step">
      <v-icon
        size="x-large"
        color="primary"
        >mdi-checkbox-marked-circle-outline</v-icon
      >
      <div
        v-if="currentPlan.provider === 'Paypal'"
        class="mt-2"
      >
        <h2>
          {{ $t('payment.paypal_sub_update_success') }}
        </h2>
        <div
          class="mt-4"
          v-html="
            $t('payment.paypal_sub_update_success_subtitle', {
              new_tier: selectedPayPlanFullName,
            })
          "
        ></div>
        <div class="mt-4">
          {{ $t('payment.paypal_receipt_note') }}
        </div>
      </div>
      <div
        v-else
        class="mt-2"
      >
        <h2>
          {{
            stripeDowngrading
              ? $t('payment.stripe_sub_downgrade_success')
              : $t('payment.stripe_sub_upgrade_success')
          }}
        </h2>
        <div
          class="mt-4"
          data-tst="downgrade_tier"
          v-html="
            stripeDowngrading
              ? $t('payment.stripe_sub_downgrade_success_subtitle', {
                  new_tier: selectedPayPlanFullName,
                })
              : $t('payment.stripe_sub_upgrade_success_subtitle', {
                  new_tier: selectedPayPlanFullName,
                })
          "
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessPaymentView',
  props: {
    currentPlan: {
      type: Object,
      required: true,
    },
    selectedPayPlanFullName: {
      type: String,
      required: true,
    },
    stripeDowngrading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
